import { useAuth } from "./lib/auth";
import { useRouter } from "./lib/router";
import { SignIn } from "./components/SignIn";
import { Dashboard } from "./components/Dashboard";
import { Pickups } from "./components/Pickups";
import { Drop } from "./components/Drop";
import { MailIn } from "./components/MailIn";
import { Orders } from "./components/Orders";
import { OrderDetail } from "./components/OrderDetail";
import { Account } from "./components/Account";
import { BottomNav } from "./components/BottomNav";
import { InstallNudge } from "./components/InstallNudge";
import { Spinner } from "./components/ui";

export function App() {
  const { data: auth, isLoading } = useAuth();
  const { path, query } = useRouter();

  if (isLoading) {
    return (
      <div className="min-h-dvh grid place-items-center bg-canvas">
        <Spinner />
      </div>
    );
  }

  // Progressive access: unauthenticated users get the sign-in screen. (Public
  // surfaces like the drop CTA still work; the personalized dashboard/pickups
  // require a session.)
  if (!auth?.authenticated) {
    return <SignIn prefillEmail={query.get("email") || undefined} />;
  }

  const email = auth.email as string;

  // Drop-off and mail-in are focused full-screen flows (own header + sticky
  // footer + in-flow Turbo) — no app tab bar, so nothing overlaps their buttons.
  if (path.startsWith("/drop")) return <Drop />;
  if (path.startsWith("/mailin")) return <MailIn />;

  let screen;
  if (path.startsWith("/orders")) screen = <Orders />;
  else if (path.startsWith("/order/")) screen = <OrderDetail orderId={decodeURIComponent(path.slice("/order/".length))} />;
  else if (path.startsWith("/pickups")) screen = <Pickups />;
  else if (path.startsWith("/account")) screen = <Account email={email} tier={auth.tier} />;
  else screen = <Dashboard email={email} />;

  return (
    <div className="min-h-dvh bg-canvas">
      <div className="max-w-md mx-auto pb-20">{screen}</div>
      <InstallNudge />
      <BottomNav />
    </div>
  );
}
